import { createChunkLoader } from 'utils/chunkLoader';

// The job page's tab chunks, loaded by its tab panels (JobTabPanels) and warmed
// by the boot warm-up (app-shell/routeMounts). Both go through one loader per
// chunk: Vite's preload helper waits for a chunk's stylesheets only on the
// first import of it, so a second, separate import could resolve, and the tab
// render, before its CSS has loaded. The panels render both through
// lazyWithReload, which also requests again a stylesheet a warm-up failed to
// load.

export const jobEditorChunk = createChunkLoader(
  () => import('pages/jobs/editor/JobEditor')
);

export const campaignDetailsChunk = createChunkLoader(
  () => import('pages/jobs/candidates/CampaignDetailsPage')
);
